{ Session }  = Application.actions()

class BaseSlideView extends Backbone.View
  # Called by the CMS when previewing the engine configuration. Reset
  # the state to "prompt" unless the answer is the only changed property.
  refresh: (params, config) ->
    @setState true, "refresh"

    answerChangeOnly = _.isEqual(
      _.omit(params.data, "answer")
      _.omit(@options.data, "answer")
    )

    if answerChangeOnly
      isCorrect =
        @options.data.answer?.incorrect is params.data.answer?.incorrect

    @options.data = params.data
    @options.metadata = params.metadata

    if answerChangeOnly and params.data.answer
      @trigger("complete", this, { isCorrect })
    else
      @undelegateEvents()
      @render(params, config)
      @delegateEvents()
      @trigger("refresh", this)
      @trigger("resize", this)

    window.setTimeout (=> @setState false, "refresh"), 0

  # Reset returns the slide to it's initial state so that the
  # template can be interacted again from scratch.
  reset: ->
    @undelegateEvents()
    @render()
    @delegateEvents()

  # Call `submit` once the template is considered complete. Don't show any
  # feedback if there is none to show, or feedback is deliberately disabled.
  submit: ->
    try
      answerDetails = @answerDetails?()
    catch err
      console.error "Error on answer details", err
      answerDetails = []

    isCorrect     = @isCorrect()
    prevState = @currentState.state

    isTooSlow     = prevState is "prompt" and
                    @options.data.game?.timer?.limit > 0

    @trigger "complete", this, { isCorrect, isTooSlow, answerDetails }

    return @next() if not @options.data.answer

    @setState("complete")
    if @options.lessonConfiguration?.hasAnswerFeedback
      @showAnswer()
    else
      @next()

  # Additional event to be fired alongside slide interaction
  # this happens when user has completed the slide
  slideCompleted: (isCorrect = @isCorrect(), answerDetails = @answerDetails?()) ->
    isInteractive = (answerDetails?.length || 0) > 0
    Application.publish("event:slide-completed") { isCorrect, isInteractive }

  # Additional event to notify that current slide is moving to the next one
  slideNext: () ->
    slideIndex = @options.slideIndex
    Application.publish("event:next-slide") { slideIndex }

  # Additional details about the interaction tracked in analytics.
  # Is an array containing all the question/answer pairs generated on the slide
  answerDetails: -> []

  # Override with the template's own logic determining whether
  # the user has successfully completed the slide.
  isCorrect: -> true

  # Add template logic to visually display the answer of the template.
  showAnswer: ->

  exit: ->
    Backbone.Events.trigger "application-exit"

  delegateEvents: ->
    super()
    @toggleNonBubblingEvents("add")
    @listenTo this, "refresh", @onRefresh
    @listenTo this, "narration-loaded",   @onNarrationLoaded
    @listenTo this, "narration-progress", @onNarrationProgress
    @listenTo this, "narration-pause",    @onNarrationComplete
    @listenTo this, "narration-complete", @onNarrationComplete

  # Undelegate events for all subviews, like draggies and number pickers.
  undelegateEvents: ->
    @stopListening()
    @toggleNonBubblingEvents("remove")

    for key, arr of this
      arr = [arr] unless _.isArray(arr)
      obj.undelegateEvents?() for obj in _.compact(arr)

    super()

  # Provide a generic interface for events which do not bubble, like scrolling
  # and loading, which are attached/detached through Backbone.View delegation
  toggleNonBubblingEvents: (dir) ->
    events =
      scroll: [
        ".content-scroll"
        ".content-sm-scroll"
        ".content-md-scroll"
        ".content-lg-scroll"
      ]

    for evt, selector of events
      for el in @el.querySelectorAll(selector.join(", "))
        el["#{dir}EventListener"](evt, this, false)

  handleEvent: (e) ->
    switch e.type
      when "scroll" then @onScroll(e)

  onScroll: (e) ->
    @trigger("scroll", e)

module.exports = BaseSlideView
